import { render, staticRenderFns } from "./GetStudents.vue?vue&type=template&id=2d6847cf&scoped=true&"
import script from "./GetStudents.vue?vue&type=script&lang=js&"
export * from "./GetStudents.vue?vue&type=script&lang=js&"
import style0 from "./GetStudents.vue?vue&type=style&index=0&id=2d6847cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6847cf",
  null
  
)

export default component.exports